interface Subscribers<T> {
    [key: string]: Set<(event: string, data: T) => void>;
}

export class EventEmitter<T = null> {
    protected subscribers: Subscribers<T> = {};

    public on(
        event: string,
        callback: (event: string, data: T) => void,
    ): () => void {
        if (!this.subscribers[event]) this.subscribers[event] = new Set();

        this.subscribers[event].add(callback);

        return () => this.off(event, callback);
    }

    protected trigger(event: string, data?: T) {
        if (!this.subscribers[event]) return;

        this.subscribers[event].forEach((cb) => cb(event, data as T));
    }

    off(event: string, callback: (event: string, data: T) => void) {
        this.subscribers[event].delete(callback);
    }
}
